import { render, staticRenderFns } from "./custom_switch.vue?vue&type=template&id=3fc43b38&scoped=true"
import script from "./custom_switch.vue?vue&type=script&lang=js"
export * from "./custom_switch.vue?vue&type=script&lang=js"
import style0 from "./custom_switch.vue?vue&type=style&index=0&id=3fc43b38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc43b38",
  null
  
)

export default component.exports